export const messages = {
    en: {
      adminIndex: {
        home: 'Home',
        platformData: 'Platform Data',
        paymentCount: 'Payment Count',
        paymentAmount: 'Payment Amount',
        repairCount: 'Repair Count',
        communityFeeStats: 'Community Fee Statistics',
        communityRepairStats: 'Community Repair Statistics'
      },
      propertyIndex: {
        home: 'Home',
        dashboard: 'Dashboard',
        communityInfo: 'Community Information',
        communityDesc: 'Core data overview',
        building: 'Building',
        house: 'House',
        shop: 'Shop',
        parkingSpace: 'Parking Space',
        residentReg: 'Resident Registration',
        registerResident: 'Register Resident',
        vehicle: 'Vehicle',
        viewVehicle: 'View Vehicles',
        unit: 'unit',
        ownerFeedback: 'Owner Feedback',
        feedbackDesc: 'Real-time feedback',
        live: 'Live',
        noFeedback: 'No feedback content currently',
        feedback: 'feedback',
        completed: 'Completed',
        followingUp: 'Following up',
        transferRepair: 'Transferred to repair order',
        repairStats: 'Repair Statistics',
        repairDesc: 'Work order efficiency analysis',
        allRepair: 'All Repairs',
        toBeDispatched: 'To be dispatched',
        processing: 'Processing',
        processed: 'Processed',
        complaintStats: 'Complaint Statistics',
        complaintDesc: 'Complaint tracking',
        allComplaint: 'All Complaints',
        repairInfo: 'Repair Info',
        unprocessed: 'Unprocessed',
        residentRegStats: 'Resident Registration Statistics',
        ownerDesc: 'Resident management overview',
        unregistered: 'Unregistered',
        registered: 'Registered',
        unboundRoom: 'Unbound Room',
        boundRoom: 'Bound Room',
        residentInfo: 'Resident Info',
        totalOwner: 'Total Residents',
        feeStatistics: 'Fee Collection',
        feeStatisticsDesc: 'Property & parking fee collection overview',
        propertyFee: 'Property Fee',
        parkingFee: 'Parking Fee',
        receivable: 'Receivable (Month)',
        received: 'Received (Month)',
        oweFee: 'Total Owe',
        receivedRooms: 'Received Count',
        collectionRate: 'Collection Rate',
        enterRoomFee: 'Go to Room Fee',
        enterCarFee: 'Go to Car Fee',
        household: 'households',
        rateTip: 'Collection rate = received this month / receivable this month × 100%',
        rateTipNumerator: 'Numerator: amount actually paid within the month (detail state 1400/1000/1200), including recovered arrears',
        rateTipDenominator: 'Denominator: total receivable of bills whose period falls within the month (paid or not)',
        rateTipNote: 'Note: the rate may exceed 100% when many historical arrears are recovered',
        receivedRoomsTip: 'Received count = objects paid this month / chargeable objects. Numerator: distinct objects paid within the month; Denominator: objects with active fee rules'
      }
    },
    zh: {
      adminIndex: {
        home: '首页',
        platformData: '平台数据',
        paymentCount: '缴费数',
        paymentAmount: '缴费金额',
        repairCount: '报修单数',
        communityFeeStats: '小区缴费统计',
        communityRepairStats: '小区报修统计'
      },
      propertyIndex: {
        home: '首页',
        dashboard: '控制台',
        communityInfo: '小区信息',
        communityDesc: '核心数据总览',
        building: '楼宇',
        house: '房屋',
        shop: '商铺',
        parkingSpace: '车位',
        residentReg: '住户登记',
        registerResident: '登记住户',
        vehicle: '车辆',
        viewVehicle: '查看车辆',
        unit: '个',
        ownerFeedback: '业主反馈',
        feedbackDesc: '实时反馈动态',
        live: '实时',
        noFeedback: '当前没有业主反馈内容',
        feedback: '反馈',
        completed: '完成',
        followingUp: '跟进中',
        transferRepair: '已转报修单',
        repairStats: '报修统计',
        repairDesc: '工单处理效率分析',
        allRepair: '全部报修',
        toBeDispatched: '待派单',
        processing: '处理中',
        processed: '已处理',
        complaintStats: '投诉统计',
        complaintDesc: '投诉处理进度追踪',
        allComplaint: '全部投诉',
        repairInfo: '报修信息',
        unprocessed: '未处理',
        residentRegStats: '住户注册统计',
        ownerDesc: '住户登记管理概览',
        unregistered: '未注册',
        registered: '已注册',
        unboundRoom: '未绑定房屋',
        boundRoom: '已绑定房屋',
        residentInfo: '住户信息',
        totalOwner: '总住户',
        feeStatistics: '收缴费用情况',
        feeStatisticsDesc: '物业费与停车费收缴总览',
        propertyFee: '物业费',
        parkingFee: '停车费',
        receivable: '当月应收',
        received: '当月已收',
        oweFee: '总欠费',
        receivedRooms: '已收户数',
        collectionRate: '收缴率',
        enterRoomFee: '进入房屋收费',
        enterCarFee: '进入车辆收费',
        household: '户',
        rateTip: '收缴率 = 本月已收金额 / 当月应收 × 100%',
        rateTipNumerator: '分子：查询月内实缴金额(缴费明细状态 1400/1000/1200)，包含追缴的历史欠费',
        rateTipDenominator: '分母：费用周期落在查询月内的账单应收合计(不区分是否缴清)',
        rateTipNote: '注意：追缴旧账较多时，收缴率可能超过 100%',
        receivedRoomsTip: '已收户数 = 本月已收户数 / 收费户数。分子：查询月内实缴的缴费对象数(去重)；分母：存在生效收费规则的对象数'
      }
    },
    'zh-TW': {
      adminIndex: {
        home: '首頁',
        platformData: '平台數據',
        paymentCount: '繳費數',
        paymentAmount: '繳費金額',
        repairCount: '報修單數',
        communityFeeStats: '小區繳費統計',
        communityRepairStats: '小區報修統計'
      },
      propertyIndex: {
        home: '首頁',
        dashboard: '控制台',
        communityInfo: '小區信息',
        communityDesc: '核心數據總覽',
        building: '樓宇',
        house: '房屋',
        shop: '商鋪',
        parkingSpace: '車位',
        residentReg: '住戶登記',
        registerResident: '登記住戶',
        vehicle: '車輛',
        viewVehicle: '查看車輛',
        unit: '個',
        ownerFeedback: '業主反饋',
        feedbackDesc: '實時反饋動態',
        live: '實時',
        noFeedback: '當前沒有業主反饋內容',
        feedback: '反饋',
        completed: '完成',
        followingUp: '跟進中',
        transferRepair: '已轉報修單',
        repairStats: '報修統計',
        repairDesc: '工單處理效率分析',
        allRepair: '全部報修',
        toBeDispatched: '待派單',
        processing: '處理中',
        processed: '已處理',
        complaintStats: '投訴統計',
        complaintDesc: '投訴處理進度追蹤',
        allComplaint: '全部投訴',
        repairInfo: '報修信息',
        unprocessed: '未處理',
        residentRegStats: '住戶注冊統計',
        ownerDesc: '住戶登記管理概覽',
        unregistered: '未注冊',
        registered: '已注冊',
        unboundRoom: '未綁定房屋',
        boundRoom: '已綁定房屋',
        residentInfo: '住戶信息',
        totalOwner: '總住戶',
        feeStatistics: '收繳費用情況',
        feeStatisticsDesc: '物業費與停車費收繳總覽',
        propertyFee: '物業費',
        parkingFee: '停車費',
        receivable: '當月應收',
        received: '當月已收',
        oweFee: '總欠費',
        receivedRooms: '已收戶數',
        collectionRate: '收繳率',
        enterRoomFee: '進入房屋收費',
        enterCarFee: '進入車輛收費',
        household: '戶',
        rateTip: '收繳率 = 本月已收金額 / 當月應收 × 100%',
        rateTipNumerator: '分子：查詢月內實繳金額(繳費明細狀態 1400/1000/1200)，包含追繳的歷史欠費',
        rateTipDenominator: '分母：費用週期落在查詢月內的賬單應收合計(不區分是否繳清)',
        rateTipNote: '注意：追繳舊賬較多時，收繳率可能超過 100%',
        receivedRoomsTip: '已收戶數 = 本月已收戶數 / 收費戶數。分子：查詢月內實繳的繳費對象數(去重)；分母：存在生效收費規則的對象數'
      }
    }
  }